<template>
  <v-col class="pt-12">
    <v-row class="pt-4">
      <v-col cols="12" class="box-header-table">
        <div class="d-flex">
          <div class="col-checkbox px-2">
            <v-simple-checkbox
              v-model="item"
              :ripple="false"
            ></v-simple-checkbox>
          </div>
          <div class="col-name text-bold px-2">
            Tên chiến dịch
          </div>
          <div class="col-type text-bold">
            Loại chiến dịch
          </div>
          <div class="col-form text-bold">
            Hình thức áp dụng
          </div>
          <div class="col-form text-bold">Mã khuyến mại</div>
          <div class="col-start-time text-bold text-center">
            Thời gian bắt đầu
          </div>
          <div class="col-end-time text-bold text-center">
            Thời gian kết thúc
          </div>
          <div class="col-status text-bold">
            Trạng thái
          </div>
          <div class="col-action text-bold text-center">
            Thao tác
          </div>
        </div>
      </v-col>
      <v-col cols="12" v-if="!data.length">
        <p v-if="isLoading" class="text-center">Đang tải dữ liệu....</p>
        <p v-if="!isLoading" class="text-center">Không có dữ liệu</p>
      </v-col>
      <template v-if="data.length">
        <v-col cols="12" v-for="(item, indexGR) in data" :key="'gr-' + indexGR">
          <!-- <div class="box-title-cate mb-3">
            <span v-for="(itemCategory, indexC) in groupProduct.fullLevelName" :key="'gr-' + indexGR + 'c' + indexC" class="box-group-cate">
              <span class="tail-cate" :style="{ backgroundImage: 'url(' +require('@/assets/tail-category.png') + ')' }">&nbsp;</span> 
              <span class="body-cate" :style="{ backgroundImage: 'url(' +require('@/assets/body-category.png') + ')' }">{{ itemCategory }}</span> 
              <span class="head-cate" :style="{ backgroundImage: 'url(' +require('@/assets/head-category.png') + ')' }">&nbsp;</span>
            </span>
          </div> -->
          <div class="item-product mb-2 pt-4 pb-8">
            <div class="d-flex product-info">
              <div class="col-checkbox px-2">
                <v-simple-checkbox
                  :ripple="false"
                ></v-simple-checkbox>
              </div>
              <div class="col-name px-2">
                {{ item.title }}
              </div>
              <div class="col-type">
                {{ typeObj[item.type] }}
              </div>
              <div class="col-form">
                {{ campaignFormObj[item.formOfApplication] }}
              </div>
              <div class="col-form">
                {{ item.promotionCode ? item.promotionCode : item.promotionSubCode }}
              </div>
              <div class="col-start-time text-center">
                {{ dateTime(item.startDate) }}
              </div>
              <div class="col-end-time text-center">
                {{ item.endDate ? dateTime(item.endDate) : '-'  }}
              </div>
              <div class="col-status">
                {{ statusObj[item.status] }}
              </div>
              <div class="col-action text-center">
                <a 
                  v-if="checkAuthorization('oms-campaign_update')"
                  class="link-edit mr-2" 
                  target="_blank" 
                  :href="`/campaign/update/${item.id}`"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Chỉnh sửa</span>
                  </v-tooltip>
                </a>
                <!-- <a class="link-edit" target="_blank" :href="`/campaign/detail/${item.id}`">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-eye
                      </v-icon>
                    </template>
                    <span>Xem chi tiết</span>
                  </v-tooltip>
                </a> -->
                <!-- <span class="ml-3 btn">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </span> -->
              </div>
            </div>
            <!-- <div class="product-skus">
              <GeneralDiscountCode :productAttributes="productAttributes" :campaign="item" />
            </div> -->
          </div>
        </v-col>
      </template>
      
    </v-row>
  </v-col>
</template>

<script>
import {
  campaignStatusFinished,
  campaignStatusCancel,
  campaignStatusInactive,
} from '../../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

// import GeneralDiscountCode from './GeneralDiscountCode.vue';

export default {
  name: 'list-product',
  components: {
    // GeneralDiscountCode,
  },
  props:{
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    campaignOptions: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      item: null,
      campaignFormObj: {},
      typeObj: {},
      statusObj: {},
      campaignStatusFinished,
      campaignStatusCancel,
      campaignStatusInactive,
    };
  },
  computed: {
  },
  async created() {
    this.campaignOptions.applicableForm.forEach((item) => {
      this.campaignFormObj[item.id] = item.name;
    });

    this.campaignOptions.type.forEach((item) => {
      this.typeObj[item.id] = item.name;
    });

    this.campaignOptions.status.forEach((item) => {
      this.statusObj[item.id] = item.name;
    });
  },
  mounted() {
    var boxHeaderTable = document.getElementsByClassName('box-header-table')[0];
    window.addEventListener("scroll", () => {
      var boxAdvanceSearch = document.getElementsByClassName('box-advance-search')[0];
      const { scrollTop } = document.documentElement;
      (scrollTop > 120) ? boxHeaderTable.style.position = 'sticky' : boxHeaderTable.style.position = 'unset';
      if (boxAdvanceSearch) {
        (scrollTop > 120) ? boxAdvanceSearch.style.top = '95px' : boxHeaderTable.style.position = '40px';
      }
    },{ passive: true });
  },
  beforeDestroy() {
  },
  methods: {
    // editProduct(product) {
    //   this.$router.push(`/products/${product.id}`)
    // },
  },
  watch: {
    // currentPage: {
    //   handler() {
    //     this.addHashToLocation( {...this.filterForm, page: this.currentPage });
    //     this.getList();
    //   }
    // },
  }
};
</script>
<style scoped lang="scss">
.box-header-table {
	background: #FAFBFF;
	top: 60px;
}
.col-checkbox {
  width: 5%;
}
.col-name {
  width: 20%;
}

.col-type {
  width: 15%;
}
.col-start-time {
  width: 15%;
}
.col-end-time {
  width: 15%;
}
.col-form {
  width: 10%;
}
.col-status {
  width: 10%;
}
.col-action {
  width: 10%;
}
.text-bold {
  font-weight: bold;
}
.box-title-cate {
  display: flex;
  color: #fff;
  font-weight: bold;

  .box-group-cate {
    display: flex;
    margin-left: -4px;
  }

  .tail-cate {
    width: 9px;
    height: 21px;
    display: inline-block;
  }
  .body-cate {
    height: 21px;
    display: inline-block;
    background-repeat: repeat-x;
    min-width: 80px;
    padding-left: 12px;
  }
  .head-cate {
    width: 10px;
    height: 21px;
    display: inline-block;
  }
}
.item-product {
  background: #FAFBFF;
  border-radius: 10px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);

  .btn {
    cursor: pointer;
  }
}
.link-edit {
  text-decoration: none !important;
}
</style>
